var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "commentsContainer" }, [
    _c(
      "ul",
      { staticClass: "annotationsList" },
      _vm._l(_vm.list, function(item) {
        return _c(
          "li",
          { key: item.id, staticClass: "annotationsGroup" },
          [
            _c("annotations-list-item", {
              attrs: { item: item, data: _vm.data, corptype: _vm.corptype },
              on: { delete: _vm.deleteAnnotation }
            })
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }